import { render, staticRenderFns } from "./Brush.vue?vue&type=template&id=0f3b7dc8&scoped=true"
import script from "./Brush.vue?vue&type=script&lang=js"
export * from "./Brush.vue?vue&type=script&lang=js"
import style0 from "./Brush.vue?vue&type=style&index=0&id=0f3b7dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b7dc8",
  null
  
)

export default component.exports